import { Directive, HostListener, Input } from '@angular/core';
import { Editor } from '@tiptap/core';
import type { IUploader } from '../uploader';
import { ImageCommandsService } from './image-commands.service';

@Directive({
    selector: '[ptImageUploadDropzone]',
    standalone: false
})
export class ImageUploadDropzoneDirective {
  @Input()
  editor: Editor;

  @Input()
  uploader: IUploader;

  constructor(private _imageCommands: ImageCommandsService) {}

  @HostListener('drop', ['$event'])
  async onDrop($event: MouseEvent): Promise<void> {
    if (!($event instanceof DragEvent) || !$event.dataTransfer?.files.length) {
      return;
    }
    $event.preventDefault();

    const coordinates = this.editor.view.posAtCoords({
      left: $event.clientX,
      top: $event.clientY,
    });

    if (!coordinates || !$event.dataTransfer) {
      return;
    }

    await this._imageCommands.upload(
      this.uploader,
      this.editor,
      coordinates.pos,
      $event.dataTransfer.files
    );
  }
}
